module.exports = __webpack_public_path__ + "static/media/Liew.230876ba.png";